const onlyContainsDigits = (str: string) => {
    return /^\d+$/.test(str);
};

export const tryParseDate = (str?: string): Date | undefined => {
    try {
        if (!str) {
            return undefined;
        }
        const time = onlyContainsDigits(str) ? parseInt(str, 10) : Date.parse(str);
        if (isNaN(time)) {
            return undefined;
        }
        return new Date(time);
    } catch {
        return undefined;
    }
};
